document.querySelectorAll('.video-slideshow').forEach((slideshow) => {
  const track = slideshow.querySelector('.video-slideshow__track');
  const slides = Array.from(slideshow.querySelectorAll('.video-slideshow__slide'));
  const dots = Array.from(slideshow.querySelectorAll('.video-slideshow__dot'));
  const prevButton = slideshow.querySelector('.video-slideshow__arrow--prev');
  const nextButton = slideshow.querySelector('.video-slideshow__arrow--next');
  if (!track || slides.length < 2) return;

  let currentIndex = 0;
  let autoplayTimer;

  function goTo(index) {
    currentIndex = (index + slides.length) % slides.length;
    track.scrollTo({ left: slides[currentIndex].offsetLeft, behavior: 'smooth' });
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === currentIndex));
  }

  function startAutoplay() {
    stopAutoplay();
    autoplayTimer = setInterval(() => goTo(currentIndex + 1), 6000);
  }

  function stopAutoplay() {
    if (autoplayTimer) clearInterval(autoplayTimer);
  }

  prevButton?.addEventListener('click', () => {
    goTo(currentIndex - 1);
    startAutoplay();
  });

  nextButton?.addEventListener('click', () => {
    goTo(currentIndex + 1);
    startAutoplay();
  });

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      goTo(i);
      startAutoplay();
    });
  });

  let scrollTimeout;
  track.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      const newIndex = slides.findIndex(
        (slide) => Math.abs(slide.offsetLeft - track.scrollLeft) < slide.clientWidth / 2
      );
      if (newIndex >= 0) {
        currentIndex = newIndex;
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === currentIndex));
      }
    }, 100);
  });

  track.addEventListener('pointerdown', stopAutoplay);
  track.addEventListener('touchstart', stopAutoplay, { passive: true });

  if (dots[0]) dots[0].classList.add('is-active');
  startAutoplay();
});
